function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useMemo, useContext } from 'react';
import { TableRow, TableSortLabel, Checkbox } from '@mui/material';
import TCell from "./TCell";
import TableContext from "./context";
var THeader = function THeader() {
  var _defaultSort$sortOrde;
  var _useContext = useContext(TableContext),
    defaultSort = _useContext.defaultSort,
    rowKey = _useContext.rowKey,
    rowSelection = _useContext.rowSelection,
    dataSource = _useContext.dataSource,
    expandable = _useContext.expandable,
    loading = _useContext.loading,
    size = _useContext.size,
    columns = _useContext.columns;
  var _useState = useState((_defaultSort$sortOrde = defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.sortOrder) !== null && _defaultSort$sortOrde !== void 0 ? _defaultSort$sortOrde : 'desc'),
    _useState2 = _slicedToArray(_useState, 2),
    order = _useState2[0],
    setOrder = _useState2[1];
  var _useState3 = useState(defaultSort === null || defaultSort === void 0 ? void 0 : defaultSort.sortOrderBy),
    _useState4 = _slicedToArray(_useState3, 2),
    orderBy = _useState4[0],
    setOrderBy = _useState4[1];
  var handleRequestSort = function handleRequestSort(property, defaultSortOrder, callBack) {
    if (orderBy === property) {
      var newOrder = order === 'asc' ? 'desc' : 'asc';
      setOrder(newOrder);
      callBack === null || callBack === void 0 ? void 0 : callBack(newOrder, property);
    } else {
      setOrder(defaultSortOrder);
      setOrderBy(property);
      callBack === null || callBack === void 0 ? void 0 : callBack(defaultSortOrder, property);
    }
  };
  var hasAllSelected = useMemo(function () {
    var _rowSelection$selecte;
    return (rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$selecte = rowSelection.selectedRowKeys) === null || _rowSelection$selecte === void 0 ? void 0 : _rowSelection$selecte.length) === dataSource.length;
  }, [dataSource, rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys]);
  var indeterminate = useMemo(function () {
    var _rowSelection$selecte2;
    return !hasAllSelected && (rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys) && (rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$selecte2 = rowSelection.selectedRowKeys) === null || _rowSelection$selecte2 === void 0 ? void 0 : _rowSelection$selecte2.length) > 0;
  }, [hasAllSelected, rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys]);
  var hasExpandableCell = useMemo(function () {
    return dataSource.some(function (data) {
      var _expandable$rowExpand;
      return expandable === null || expandable === void 0 ? void 0 : (_expandable$rowExpand = expandable.rowExpandable) === null || _expandable$rowExpand === void 0 ? void 0 : _expandable$rowExpand.call(expandable, data);
    });
  }, [dataSource, expandable]);
  var onSelectedAllRowKeysChange = function onSelectedAllRowKeysChange(event) {
    if (event.target.checked) {
      var _rowSelection$onChang;
      var rowKeys = dataSource.map(function (data) {
        return data[rowKey];
      });
      rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$onChang = rowSelection.onChange) === null || _rowSelection$onChang === void 0 ? void 0 : _rowSelection$onChang.call(rowSelection, rowKeys, dataSource);
    } else {
      var _rowSelection$onChang2;
      rowSelection === null || rowSelection === void 0 ? void 0 : (_rowSelection$onChang2 = rowSelection.onChange) === null || _rowSelection$onChang2 === void 0 ? void 0 : _rowSelection$onChang2.call(rowSelection, [], []);
    }
  };
  return /*#__PURE__*/React.createElement(TableRow, null, hasExpandableCell && !loading && /*#__PURE__*/React.createElement(TCell, {
    sx: {
      width: 80
    }
  }), rowSelection && !loading && dataSource.length !== 0 && /*#__PURE__*/React.createElement(TCell, {
    sx: {
      width: 64,
      paddingInlineStart: 1
    },
    className: "cx-selection-column",
    size: size
  }, /*#__PURE__*/React.createElement(Checkbox, {
    size: "small",
    sx: {
      color: 'text.auxiliary'
    },
    checked: hasAllSelected,
    indeterminate: indeterminate,
    onChange: onSelectedAllRowKeysChange
  })), columns.map(function (column) {
    return /*#__PURE__*/React.createElement(TCell, {
      key: column.dataIndex,
      align: column.align || 'left',
      sx: {
        width: column.width,
        minWidth: column.minWidth
      },
      size: size
    }, column.sorter ? /*#__PURE__*/React.createElement(TableSortLabel, {
      active: orderBy === column.dataIndex,
      direction: orderBy === column.dataIndex ? order : column.defaultSortOrder || 'desc',
      onClick: function onClick() {
        handleRequestSort(column.dataIndex, column.defaultSortOrder || 'desc', column.sorter);
      }
    }, column.title) : column.title);
  }));
};
export default THeader;